import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';

import { ETag } from '../../../shared/interfaces/tag.interface';
import {
  EPicklistOderStatus,
  EPicklistOrderSource,
  PickListInterface,
  PicklistPacking,
} from '../../interfaces';

@Component({
  selector: 'lum-picklist-packing-table-actions',
  templateUrl: './picklist-packing-table-actions.component.html',
  styleUrls: ['./picklist-packing-table-actions.component.scss'],
})
export class PicklistPackingTableActionsComponent implements OnChanges {
  @Output()
  shipEvent = new EventEmitter<number>();

  @Output()
  onHoldEvent = new EventEmitter<number>();

  @Output()
  printLabelEvent = new EventEmitter<number>();

  @Output()
  printLabelWithPackingSlipEvent = new EventEmitter<number>();

  @Output()
  exportPackingSlipEvent = new EventEmitter<number>();

  @Output()
  verifyEvent = new EventEmitter<PicklistPacking>();

  @Output()
  flagOrderEvent = new EventEmitter<number>();

  @Input()
  showActions :boolean;

  @Input()
  data :PicklistPacking;

  @Input()
  key :number;

  @Input()
  picklist :PickListInterface | null = null;

  @Input()
  loadingShipItems :{ [id :number] :boolean } = {};

  @Input()
  loadingBulkShip :boolean = false;

  matTooltipMessage = 'Tagged as ' + ETag.FLAGGED;
  isShipDisabled :boolean = false;

  ngOnChanges() :void {
    this.isShipDisabled =
      this.loadingShipItems[this.data.id] ||
      this.loadingBulkShip ||
      (this.data.scanToVerify ? !this.data.verified : false);
  }

  get showActionButtons() :boolean {
    // return this.showActions && this.enableActions;
    return this.showActions && this.data.shippable;
  }

  get enableActions() :boolean {
    const allowedOrderStatus :string[] = [
      EPicklistOderStatus.AWAITING_SHIPMENT,
      EPicklistOderStatus.PARTIALLY_SHIPPED,
      EPicklistOderStatus.PENDING,
    ];

    return allowedOrderStatus.includes(this.data.orderStatus);
  }

  get canPrintLabel() :boolean {
    const order = this.picklist?.orders?.find((order) => order.id === this.data.id);

    if (!order) {
      return false;
    }

    if (
      order.source === EPicklistOrderSource.LUMINOUS &&
      order.shipstationOrderId
    ) {
      return true;
    }

    if (order.source === EPicklistOrderSource.SHIPSTATION && order.channelId > 0) {
      return true;
    }

    return false;
  }
}
